import { createContext } from "react";

export const CheckboxContext = createContext({
  isChecked: () => false,
  toggleValue: () => {},
});
